import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";

function FaqList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [tags, setTags] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getTags();
    const interval = setInterval(() => {
      getTags();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  const getTags = () => {
    axios.get(URL_API + "auth/admin/faqs").then((response) => {
      if (response.data.status === 200) {
        setTags(response.data.tags);
      }
    });
  };

  const destroyTag = (id) => {
    axios
      .post(URL_API + `auth/admin/faqs/destroy/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/faqs");
          toast.success("Faq Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getTags();
        }
      });
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" style={{ fontWeight: "100" }}>
                  Barakah Hijama | <i class="fa fa-home" aria-hidden="true"></i> |
                  Faqs
                </CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <Link to={`/admin/faq/create`}>
                  <strong>Add Faq + </strong>
                </Link>
              </div>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Answer</th>
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {tags.map(
                      (tag, index) => {
                        return (
                          <>
                            <tr>
                              <td>{index + 1}</td>
                              <td>{tag?.name}</td>
                              <td>{tag?.answer}</td>
                              <td>
                                {moment(tag?.created_at).format(" DD MMMM,YYYY")}
                              </td>
                              <td>
                                {/* <a style={{color:"#77ac54"}} href={`article/detail/${tag.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                                <Link to={`faq/edit/${tag.id}`}>
                                  <i class="far fa-edit fa-lg"></i>
                                </Link>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <br />
                                <a
                                  style={{ color: "red" }}
                                  onClick={() => destroyTag(tag.id)}
                                >
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a>
                              </td>
                            </tr>
                          </>
                        );
                      }
                      // )
                    )}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default FaqList;
